import { makeStyles, useTheme } from '@material-ui/core/styles';

export const Theme = useTheme;

export const useStyles = makeStyles(theme => {
	return {
		root: {},
		header: {
			fontSize: 38,
			fontWeight: 700,
			marginBottom: 40
		},
		aboutYouBox: {},
		aboutYouTitle: {
			fontSize: 16,
			fontWeight: 500,
			marginBottom: 30
		},
		aboutYouInput: {
			marginBottom: 20,
			'& .MuiIconButton-root': {
				padding: '0 !important'
			}
		},
		userConsentWrapper: {
			marginBottom: 20
		}
	};
});
